import { observable, action } from 'mobx';
import { ErrorMessageType, REG_SPACE } from '../../utils/Constants';

/**
 * This holds some UI states and logic for the order tracking form view.
 */
export class OrderTracking {
    @observable public isLoading: boolean = false;
    @observable public queryOrderNumber: string = '';
    @observable public errorMessageType: ErrorMessageType | undefined;

    private orderNumberValidationRegex: RegExp;

    constructor(orderNumberValidationRegex: string) {
        if (orderNumberValidationRegex) {
            this.orderNumberValidationRegex = new RegExp(orderNumberValidationRegex);
        }
    }

    @action
    public setIsLoading = (isLoading: boolean) => {
        this.isLoading = isLoading;
    };

    @action
    public setQueryOrderNumber = (orderNumber: string) => {
        if (!this.orderNumberValidationRegex) {
            return;
        }

        this.queryOrderNumber = orderNumber?.replace(REG_SPACE, '');

        if (!this.queryOrderNumber || this.orderNumberValidationRegex.test(this.queryOrderNumber)) {
            this.setErrorMessageType();
        } else {
            this.setErrorMessageType(ErrorMessageType.ORDER_NUMBER_INVALID);
        }
    };

    @action
    public setErrorMessageType = (errorMessageType?: ErrorMessageType) => {
        this.errorMessageType = errorMessageType;
    };
}
